module.exports = __webpack_public_path__ + "img/ui-radios.5e1372bd.svg";